// extracted by mini-css-extract-plugin
export default {"video_player":"_1Hhv1","videoPlayer":"_1Hhv1","video_container":"jjB_2","videoContainer":"jjB_2"};